import { Component, Input, OnInit } from '@angular/core';
import { Account } from '@jaimo-solutions-gmbh/platform-services-module';
import { State } from 'src/helpers';
import { ScrollService } from '../../services/scroll.service';
import { VerifiedTooltipComponent } from '@jaimo-solutions-gmbh/stage-components';
import { faChevronLeft, faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { getImagePath } from 'src/app/utils/getImagePath';
import { ModalController } from '@ionic/angular';
import { MobilePopoverComponent } from 'src/app/modals/mobile-popover/mobile-popover.component';

@Component({
  selector: 'app-mobile-header',
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.scss'],
})
export class MobileHeaderComponent implements OnInit {
  VerifiedComponent = VerifiedTooltipComponent;
  @Input() account: Account;
  @Input() state: State;

  showSubscribed = true;
  showStageInTitle = false;

  ellipsis = faEllipsisV;
  backIcon = faChevronLeft;

  searchText: string = '';

  constructor(
    scrollService: ScrollService,
    private modalCtrl: ModalController,
    private router: Router
  ) {
    scrollService.scrollPositionSubject.subscribe((value: number) => {
      this.showStageInTitle = value > 220 && this.state === 'stage';
    });
  }

  ngOnInit() {}

  ngOnChanges() {}

  onInput = (value: string) => {
    this.searchText = value;
    if (!value) {
      this.clear();
    } else {
      this.router.navigate([`/search`], {
        queryParams: { searchText: this.searchText },
      });
    }
  };

  onFocus = () => {
    this.router.navigate([`/search`], {
      queryParams: { searchText: this.searchText },
    });
  };

  clear = () => {
    this.searchText = '';
    this.router.navigate([this.state ?? '']);
  };

  openSettings = async () => {
    const modal = await this.modalCtrl.create({
      component: MobilePopoverComponent,
      cssClass: 'settings-popover',
      componentProps: {
        account: this.account,
      },
    });

    modal.present();
  };

  getImage = (filename) => getImagePath() + filename;

  getTitle = () => {
    switch (this.state) {
      case 'main':
        return 'Home';
      case 'explore':
        return 'Entdecken';
      case 'followed':
        return 'Folge ich';
      case 'stage':
        return this.account?.name;
      default:
        break;
    }
  };
}
